import { StyleSheet } from 'react-native';
import { Image } from 'expo-image';
import TextLato from '../text/text-lato/TextLato';
import { brand, neutrals } from 'src/theme/colors';
import { PressableHovered } from 'src/editor-v3/components/pressable-hovered/PressableHovered';
import { FocusGroups } from '../focus-provider/FocusProvider.constants';

export interface BottomBarEditCardProps {
  card: {
    uri: string;
    text: string;
    onPress: () => void;
  };
  isSelected: boolean;
  focusId: string;
  focusOrder: number;
}
export const BottomBarEditCard = ({ card, isSelected, focusId, focusOrder }: BottomBarEditCardProps) => {
  return (
    <PressableHovered
      onPress={card.onPress}
      style={[style.container, isSelected && style.selected]}
      innerStyle={style.inner}
      testID={focusId}
      focusId={focusId}
      focusOrder={focusOrder}
      focusGroup={FocusGroups.BOTTOM_SHEET}
      accessibilityLabel={card.text}
      accessibilityRole="radio"
      accessibilityState={{ checked: isSelected }}
    >
      <Image source={`${card.uri}`} style={style.image} />
      <TextLato style={[style.text, isSelected && style.textSelected]}>{card.text}</TextLato>
    </PressableHovered>
  );
};

const style = StyleSheet.create({
  container: {
    width: 109,
    height: 120,
    borderRadius: 10,
    borderWidth: 2,
    borderColor: 'transparent',
    padding: 4,
    backgroundColor: neutrals.white,
  },
  selected: {
    backgroundColor: brand.main.variations['lighterWater-3'],
    borderColor: brand.main.water,
  },
  inner: {
    flex: 1,
  },
  image: {
    flex: 1,
    borderRadius: 10,
    zIndex: -1,
    position: 'relative',
  },
  text: {
    fontWeight: 400,
    fontSize: 14,
    lineHeight: 21,
    color: neutrals.neutralGrays.graphite,
    textAlign: 'center',
    width: '100%',
  },
  textSelected: {
    fontWeight: 700,
  },
});
